import { useProjectListener } from '../hooks/useProjectListener';

interface Props {
    children: React.ReactNode;
}

export const StatusListener = ({ children }: Props) => {
    useProjectListener();

    return <>{children}</>;
};
